<script setup lang="ts">
const { locale } = useI18n();

const bookImage = computed(() => {
  if (locale.value === "it") {
    return "/images/elements/a-arte-da-influencia-livro-comprar-it.png";
  }
  return "/images/elements/a-arte-da-influencia-livro-comprar.png";
});
</script>

<template>
  <UtilsSection
    container-class="md:flex-row flex-col flex gap-10 items-center max-w-screen-xl"
    class="relative overflow-hidden bg-[#070d18] text-white py-20"
  >
    <div class="md:w-2/5" data-aos="fade-right">
      <img :src="bookImage" :alt="$t('book-title')" class="w-full drop-shadow-2xl" />
    </div>

    <div class="md:w-3/5 flex flex-col gap-6">
      <p
        class="text-[#FEE000] font-neutron italic text-2xl md:text-4xl leading-snug"
        data-aos="fade-up"
      >
        {{ $t("buy-now.description-p-5") }}
      </p>

      <p class="text-white/70 text-lg leading-relaxed" data-aos="fade-up">
        {{ $t("buy-now.description-p-1") }}
        <strong class="text-white">"{{ $t("book-title") }}"</strong>
        {{ $t("buy-now.description-p-2") }}
      </p>

      <div class="flex flex-col sm:flex-row gap-4 pt-2" data-aos="fade-up">
        <UtilsButton as="a" href="#subscribe-section" scroll-to="subscribe-section">
          {{ $t("buy-now.button") }}
          <template #append>
            <Icon name="ic:round-arrow-right" class="text-2xl" />
          </template>
        </UtilsButton>
      </div>
    </div>
  </UtilsSection>
</template>
